(function () {
  if (window.FabCpCropper) return;

  const CROPPER_CSS = 'https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.6.2/cropper.min.css';
  const CROPPER_JS  = 'https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.6.2/cropper.min.js';

  let cropperLoadingPromise = null;

  function loadCropperOnce() {
    if (cropperLoadingPromise) return cropperLoadingPromise;
    cropperLoadingPromise = new Promise((resolve, reject) => {
      if (!document.querySelector(`link[href="${CROPPER_CSS}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = CROPPER_CSS;
        document.head.appendChild(link);
      }
      if (window.Cropper) { resolve(); return; }
      const s = document.createElement('script');
      s.src = CROPPER_JS;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error('cropper_load_failed'));
      document.head.appendChild(s);
    });
    return cropperLoadingPromise;
  }

  function readFileAsDataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error('file_read_failed'));
      reader.readAsDataURL(file);
    });
  }

  function buildModalDom() {
    const overlay = document.createElement('div');
    overlay.className = 'fab-cp-cropper';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Crop your photo');
    overlay.innerHTML = `
      <div class="fab-cp-cropper__sheet">
        <div class="fab-cp-cropper__stage">
          <img class="fab-cp-cropper__img" alt="">
        </div>
        <div class="fab-cp-cropper__controls">
          <div class="fab-cp-cropper__zoom">
            <button type="button" class="fab-cp-cropper__zoom-btn" data-fab-cp-zoom-out aria-label="Zoom out">−</button>
            <input type="range" class="fab-cp-cropper__zoom-slider" data-fab-cp-zoom-slider min="0" max="100" value="0">
            <button type="button" class="fab-cp-cropper__zoom-btn" data-fab-cp-zoom-in aria-label="Zoom in">+</button>
          </div>
          <div class="fab-cp-cropper__pills">
            <button type="button" class="fab-cp-cropper__pill is-active" data-fab-cp-orient="portrait">
              <span class="fab-cp-cropper__pill-icon fab-cp-cropper__pill-icon--portrait" aria-hidden="true"></span>
              <span>Portrait</span>
            </button>
            <button type="button" class="fab-cp-cropper__pill" data-fab-cp-orient="landscape">
              <span class="fab-cp-cropper__pill-icon fab-cp-cropper__pill-icon--landscape" aria-hidden="true"></span>
              <span>Landscape</span>
            </button>
            <button type="button" class="fab-cp-cropper__pill" data-fab-cp-rotate>
              <span class="fab-cp-cropper__pill-icon fab-cp-cropper__pill-icon--rotate" aria-hidden="true">↻</span>
              <span>Rotate</span>
            </button>
          </div>
          <button type="button" class="fab-cp-cropper__confirm" data-fab-cp-confirm>Confirm</button>
          <button type="button" class="fab-cp-cropper__upload-new" data-fab-cp-upload-new>
            <span aria-hidden="true">+</span> Upload new image
          </button>
        </div>
        <button type="button" class="fab-cp-cropper__close" data-fab-cp-close aria-label="Cancel">×</button>
      </div>
    `;
    return overlay;
  }

  function FabCpCropper(opts) {
    this.opts = opts || {};
    this.modal = null;
    this.cropper = null;
    this.orientation = 'portrait';
    this._resolve = null;
    this._reject = null;
  }

  FabCpCropper.prototype.open = async function (file) {
    await loadCropperOnce();
    if (!window.Cropper) throw new Error('cropper_not_loaded');

    const dataUrl = await readFileAsDataUrl(file);
    this.modal = buildModalDom();
    document.body.appendChild(this.modal);
    document.documentElement.classList.add('fab-cp-cropper-open');

    const img = this.modal.querySelector('.fab-cp-cropper__img');
    img.src = dataUrl;

    this._bindUi();

    return new Promise((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
      img.addEventListener('load', () => this._initCropper(img), { once: true });
    });
  };

  FabCpCropper.prototype._initCropper = function (imgEl) {
    const self = this;
    this.cropper = new window.Cropper(imgEl, {
      viewMode: 1,
      aspectRatio: this._currentAspectRatio(),
      autoCropArea: 0.95,
      dragMode: 'move',
      background: false,
      modal: true,
      guides: false,
      center: false,
      highlight: false,
      cropBoxResizable: false,
      cropBoxMovable: false,
      toggleDragModeOnDblclick: false,
      responsive: true,
      restore: false,
      checkOrientation: true,
      zoom(event) {
        const data = self.cropper.getImageData();
        if (!data) return;
        if (data.naturalWidth && event.detail.ratio < (data.width / data.naturalWidth) * 0.5) {
          event.preventDefault();
        }
      },
    });
    setTimeout(() => this._syncZoomSliderFromCropper(), 50);
  };

  FabCpCropper.prototype._currentAspectRatio = function () {
    return this.orientation === 'landscape' ? 4 / 3 : 3 / 4;
  };

  FabCpCropper.prototype._bindUi = function () {
    const self = this;
    const m = this.modal;

    m.querySelector('[data-fab-cp-close]').addEventListener('click', () => self._cancel());
    m.querySelector('[data-fab-cp-confirm]').addEventListener('click', () => self._confirm());
    m.querySelector('[data-fab-cp-upload-new]').addEventListener('click', () => self._cancel('upload_new'));

    m.querySelectorAll('[data-fab-cp-orient]').forEach((btn) => {
      btn.addEventListener('click', () => {
        m.querySelectorAll('[data-fab-cp-orient]').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        self.orientation = btn.dataset.fabCpOrient;
        if (self.cropper) {
          self.cropper.setAspectRatio(self._currentAspectRatio());
          self.cropper.reset();
        }
      });
    });

    m.querySelector('[data-fab-cp-rotate]').addEventListener('click', () => {
      if (!self.cropper) return;
      self.cropper.rotate(90);
    });

    m.querySelector('[data-fab-cp-zoom-in]').addEventListener('click', () => {
      if (!self.cropper) return;
      self.cropper.zoom(0.1);
      self._syncZoomSliderFromCropper();
    });
    m.querySelector('[data-fab-cp-zoom-out]').addEventListener('click', () => {
      if (!self.cropper) return;
      self.cropper.zoom(-0.1);
      self._syncZoomSliderFromCropper();
    });
    const slider = m.querySelector('[data-fab-cp-zoom-slider]');
    slider.addEventListener('input', () => {
      if (!self.cropper) return;
      const data = self.cropper.getImageData();
      if (!data || !data.naturalWidth) return;
      const minRatio = (data.width / data.naturalWidth);
      const max = minRatio * 4;
      const t = parseFloat(slider.value) / 100;
      const target = minRatio + (max - minRatio) * t;
      self.cropper.zoomTo(target);
    });

    document.addEventListener('keydown', this._onKey = (e) => {
      if (e.key === 'Escape') self._cancel();
    });
  };

  FabCpCropper.prototype._syncZoomSliderFromCropper = function () {
    if (!this.cropper) return;
    const data = this.cropper.getImageData();
    if (!data || !data.naturalWidth) return;
    const slider = this.modal.querySelector('[data-fab-cp-zoom-slider]');
    const minRatio = (data.width / data.naturalWidth);
    const currentScale = data.width / data.naturalWidth;
    const max = minRatio * 4;
    const t = max > minRatio ? (currentScale - minRatio) / (max - minRatio) : 0;
    slider.value = String(Math.max(0, Math.min(100, t * 100)));
  };

  FabCpCropper.prototype._confirm = async function () {
    if (!this.cropper) return;
    const cropData = this.cropper.getData(true);
    const canvas = this.cropper.getCroppedCanvas({
      maxWidth: 2000,
      maxHeight: 2000,
      fillColor: '#fff',
      imageSmoothingEnabled: true,
      imageSmoothingQuality: 'high',
    });
    if (!canvas) {
      this._reject(new Error('crop_canvas_failed'));
      return;
    }
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.92));
    const dataUrl = canvas.toDataURL('image/jpeg', 0.92);

    const result = {
      blob,
      dataUrl,
      orientation: this.orientation,
      crop_box: {
        x: Math.round(cropData.x),
        y: Math.round(cropData.y),
        width: Math.round(cropData.width),
        height: Math.round(cropData.height),
        rotate: cropData.rotate || 0,
      },
      width:  canvas.width,
      height: canvas.height,
    };
    const resolveFn = this._resolve;
    this._teardown();
    resolveFn(result);
  };

  FabCpCropper.prototype._cancel = function (reason) {
    const rejectFn = this._reject;
    this._teardown();
    rejectFn(new Error(reason || 'cancelled'));
  };

  FabCpCropper.prototype._teardown = function () {
    if (this.cropper) { try { this.cropper.destroy(); } catch (_) {} this.cropper = null; }
    if (this.modal && this.modal.parentNode) this.modal.parentNode.removeChild(this.modal);
    document.documentElement.classList.remove('fab-cp-cropper-open');
    if (this._onKey) document.removeEventListener('keydown', this._onKey);
    this._onKey = null;
    this._resolve = null;
    this._reject = null;
  };

  window.FabCpCropper = FabCpCropper;
})();
